import { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Divider,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { FilePond, registerPlugin } from "react-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  uploadExperienceCoverImage,
  deleteImageFile,
  editExperienceImages,
} from "src/actions/ExperienceActions";

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview
);

// Register FilePond plugins
registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginFileValidateType,
  FilePondPluginFileValidateSize,
  FilePondPluginImagePreview
);

const UpdateExperienceImages = ({
  uploadExperienceCoverImage,
  deleteImageFile,
  editExperienceImages,
  experience,
  ...rest
}) => {
  const navigate = useNavigate();
  const [files, setFiles] = useState([]);
  const [uploadedImages, setUploadedImages] = useState([]);
  // const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (uploadedImages.length < 3) {
      // setError("Please upload at least 3 images");
      return;
    }

    try {
      const obj = {
        ...experience,
        coverImage_URL: uploadedImages[0],
        other_images: uploadedImages.map((image_url) => ({ image_url })),
      };
      await editExperienceImages(obj, experience.id, navigate);
    } catch (err) {
      // setError("Failed to save images. Please try again.");
    }
  };

  return (
    <Container maxWidth={true} style={{ marginTop: 50 }}>
      <form {...rest} onSubmit={handleSubmit}>
        <Card>
          <CardHeader subheader="Experience Image" title="Upload Images" />
          <Divider />
          <CardContent>
            <FilePond
              files={files}
              onupdatefiles={setFiles}
              allowMultiple={true}
              maxFiles={10}
              allowImageResize={true}
              imageResizeTargetWidth={1200}
              imageResizeTargetHeight={800}
              imageResizeMode="cover"
              allowRemove={true}
              acceptedFileTypes={["image/*"]}
              maxFileSize="5MB"
              server={{
                process: async (
                  fieldName,
                  file,
                  metadata,
                  load,
                  error,
                  progress,
                  abort
                ) => {
                  try {
                    const formData = new FormData();
                    formData.append("file", file);
                    const res = await uploadExperienceCoverImage(formData);
                    setUploadedImages((prev) => [...prev, res]);
                    load();
                  } catch (err) {
                    error("Upload failed");
                    // setError("Failed to upload image. Please try again.");
                  }
                  return {
                    abort: () => {
                      abort();
                    },
                  };
                },
                revert: async (uniqueFileId, load) => {
                  try {
                    // const imageToDelete = uploadedImages.find(
                    //   (img) => img.path === uniqueFileId
                    // );
                    // if (imageToDelete) {
                    //   await deleteImageFile({ Key: imageToDelete.Key });
                    //   setUploadedImages((prev) =>
                    //     prev.filter((img) => img.path !== uniqueFileId)
                    //   );
                    // }
                    load();
                  } catch (err) {
                    toast.error("Failed to delete image. Please try again.");
                    // setError("Failed to delete image. Please try again.");
                    load();
                  }
                },
              }}
              labelIdle='Drag & drop images or <span class="filepond--label-action">Browse</span>'
            />
          </CardContent>
          <Divider />
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              p: 2,
            }}
          >
            <Button
              color="primary"
              variant="contained"
              type="submit"
              // onClick={() => console.log("submit")}
            >
              Save
            </Button>
          </Box>
        </Card>
      </form>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  experience: state.fetchedExp.experience,
});

export default connect(mapStateToProps, {
  uploadExperienceCoverImage,
  deleteImageFile,
  editExperienceImages,
})(UpdateExperienceImages);
